import { FC } from "react";
import {
  IconCheck,
  IconCheckbox,
  IconPlayerPause,
  IconPlayerPlay,
} from "@tabler/icons-react";
import { Button } from "@mantine/core";
import { Time } from "../../../../Components/Time";

interface TimeButtonProps {
  start: () => Promise<unknown>;
  pause: () => Promise<unknown>;
  resume: () => Promise<unknown>;
  freezeRegularTime: () => Promise<unknown>;
  time: number;
  running: boolean;
  regularTimeOver: boolean;
  freezed: boolean;
  started: boolean;
  regieReady?: boolean;
}

export const TimeButton: FC<TimeButtonProps> = (props) => {
  const {
    time,
    running,
    regularTimeOver,
    freezed,
    started,
    start,
    pause,
    resume,
    freezeRegularTime,
    regieReady,
  } = props;

  const getClickHandler = (): (() => Promise<unknown>) => {
    if (regularTimeOver) return freezeRegularTime;
    if (!started) return start;
    if (running) return pause;
    return resume;
  };

  const getIcon = () => {
    if (freezed) return <IconCheckbox size={80} />;
    if (regularTimeOver) return <IconCheck size={80} />;
    if (running) return <IconPlayerPause size={80} />;
    return <IconPlayerPlay size={80} />;
  };

  return (
    <Button
      size="xl"
      color={running ? "green" : "red"}
      leftSection={getIcon()}
      styles={() => ({
        root: { height: 150, fontSize: 60 },
      })}
      fullWidth
      disabled={freezed || !regieReady}
      onClick={getClickHandler()}
    >
      {!regieReady ? (
        "Warte auf Regie"
      ) : !regularTimeOver ? (
        <Time time={time} />
      ) : freezed ? (
        <>Festgeschrieben</>
      ) : (
        <>Festschreiben</>
      )}
    </Button>
  );
};
